.scrim {
  position: fixed;
  inset: 0;
  background: rgba(20, 18, 16, 0.55);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 100;
  padding: 0;
}

.panel {
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  flex-direction: column;
  max-height: 100dvh;
  overflow: hidden;
}

.bar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.icon { color: var(--color-ink-soft); transform: scale(1.4); }

.input {
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  font: inherit;
  font-size: 1.6rem;
  font-weight: 500;
  color: var(--color-ink);
  padding: 10px 0;
  min-width: 0;
  letter-spacing: -0.005em;
}

.input::placeholder { color: rgba(0, 0, 0, 0.32); font-weight: 400; }

.close {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  color: var(--color-ink);
}

.body {
  overflow-y: auto;
  padding: 8px 0 16px;
}

.muted {
  padding: 32px 24px;
  color: var(--color-ink-soft);
  font-size: 1.15rem;
  line-height: 1.55;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  display: grid;
  grid-template-columns: 110px 1fr auto;
  gap: 20px;
  align-items: center;
  width: 100%;
  padding: 18px 24px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font: inherit;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.row:hover, .row:focus-visible {
  background: var(--color-bone);
  outline: none;
}

.thumb {
  width: 110px;
  height: 110px;
  object-fit: cover;
  background: var(--color-bone);
  border-radius: 8px;
}

.meta { min-width: 0; display: flex; flex-direction: column; gap: 6px; }

.name {
  font-weight: 700;
  font-size: 1.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.15;
  letter-spacing: -0.005em;
}

.sub {
  font-size: 1.05rem;
  color: var(--color-ink-soft);
  letter-spacing: 0.02em;
  display: flex;
  gap: 8px;
  text-transform: capitalize;
}

.price {
  font-size: 1.3rem;
  font-weight: 700;
  white-space: nowrap;
}

.viewAll {
  display: block;
  text-align: center;
  padding: 20px;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-ember-dark);
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

@media (min-width: 700px) {
  .panel {
    margin-top: 56px;
    max-height: 70vh;
    border-radius: 6px;
    box-shadow: var(--shadow-soft);
  }
}
